import { createAction } from "redux-actions";
import { PostConstants } from "../constants/post.constants";

export const newPost = createAction(PostConstants.NEW_POST);
export const updatePost = createAction(PostConstants.UPDATE_POST);
export const submitPost = createAction(PostConstants.SUBMIT_POST);
export const submitPostFailure = createAction(
    PostConstants.SUBMIT_POST_FAILURE
);
export const submitPostSuccess = createAction(
    PostConstants.SUBMIT_POST_SUCCESS
);
export const closePost = createAction(PostConstants.CLOSE_POST);

export const togglePostReaction = createAction(
    PostConstants.TOGGLE_POST_REACTION
);
export const togglePostReactionSuccess = createAction(
    PostConstants.TOGGLE_POST_REACTION_SUCCESS
);
export const togglePostReactionFailure = createAction(
    PostConstants.TOGGLE_POST_REACTION_FAILURE
);

export const editPost = createAction(PostConstants.EDIT_POST);

export const deletePost = createAction(PostConstants.DELETE_POST);
export const deletePostSuccess = createAction(
    PostConstants.DELETE_POST_SUCCESS
);
export const deletePostFailure = createAction(
    PostConstants.DELETE_POST_FAILURE
);

export const reportPost = createAction(PostConstants.REPORT_POST);
export const reportPostSuccess = createAction(
    PostConstants.REPORT_POST_SUCCESS
);
export const reportPostFailure = createAction(
    PostConstants.REPORT_POST_FAILURE
);

export const copyLink = createAction(PostConstants.COPY_LINK);

export function determinePostAction(action) {
    switch (action) {
        case "edit":
            return editPost;
        case "delete":
            return deletePost;
        case "report":
            return reportPost;
        case "copyLink":
            return copyLink;
        default:
            return () => ({
                type: "no-op"
            });
    }
}



// WEBPACK FOOTER //
// ./src/actions/post.actions.js